import * as React from 'react';

import IntroModal from 'bundles/degree-home/components/IntroModal';
import { hasKey, storeKey } from 'bundles/ondemand/utils/onDemandTutorialViewsApi';

import _t from 'i18n!nls/degree-home';

import 'css!./__styl__/IntroModalWrapper';

type Props = {
  isMasterTrack: boolean;
};

type State = {
  showModal: boolean;
};

class IntroModalWrapper extends React.Component<Props, State> {
  state = {
    showModal: false,
  };

  componentDidMount() {
    this.shouldShowPromise()
      .then((shouldShow) => {
        if (shouldShow) {
          this.setState({
            showModal: true,
          });
          this.markShown();
        }
      })
      .done();
  }

  handleClose = () => {
    this.setState({
      showModal: false,
    });
  };

  getKey = () => {
    const { isMasterTrack } = this.props;
    if (isMasterTrack) {
      return 'MasterTrackIntroModalWrapper';
    }
    return 'IntroModalWrapper';
  };

  shouldShowPromise = () => {
    // Display the degree intro modal if this is the user's first visit to degree home.
    return hasKey(this.getKey()).then((keyExists) => !keyExists);
  };

  markShown = () => {
    storeKey(this.getKey());
  };

  render() {
    const { showModal } = this.state;
    if (!showModal) {
      return null;
    }

    return (
      <div className="rc-IntroModalWrapper">
        <IntroModal
          modalName={_t('Degree Dashboard Intro')}
          trackingName="degree_intro_modal"
          handleClose={this.handleClose}
        />
      </div>
    );
  }
}

export default IntroModalWrapper;
